var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 91,
    viewBox: "0 0 84 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8633 17.4019C33.6418 15.1805 30.6289 13.9325 27.4873 13.9325C24.3457 13.9325 21.3328 15.1805 19.1113 17.4019C16.8899 19.6234 15.6419 22.6363 15.6419 25.7779C15.6419 28.9195 16.8899 31.9324 19.1113 34.1538L40.8626 55.9051C41.1649 56.2072 41.5747 56.3769 42.002 56.3769C42.4293 56.3769 42.8391 56.2072 43.1413 55.9051L64.8926 34.1538C66.0032 33.0563 66.8858 31.7501 67.4898 30.3102C68.0937 28.8704 68.407 27.3253 68.4117 25.7639C68.4163 24.2026 68.1122 22.6557 67.5169 21.2122C66.9216 19.7688 66.0467 18.4573 64.9427 17.3532C63.8387 16.2491 62.5273 15.3741 61.0839 14.7787C59.6405 14.1832 58.0936 13.879 56.5323 13.8835C54.9709 13.8881 53.4258 14.2013 51.9859 14.8051C50.546 15.4089 49.2397 16.2914 48.1421 17.4019L42.002 23.542L35.8633 17.4019ZM12.2752 10.5658C20.4482 2.39421 33.5611 2.17186 42.002 9.90013C50.4442 2.17186 63.5558 2.39421 71.7287 10.5658C80.1296 18.968 80.1296 32.5878 71.7287 40.99L49.9775 62.7412C48.9301 63.7886 47.6867 64.6194 46.3183 65.1863C44.9499 65.7531 43.4832 66.0448 42.002 66.0448C40.5208 66.0448 39.0541 65.7531 37.6857 65.1863C36.3172 64.6194 35.0739 63.7886 34.0265 62.7412L12.2752 40.99C3.8744 32.5878 3.8744 18.968 12.2752 10.5658Z",
    fill: "url(#paint0_radial_59_3757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9085 67.0015C30.9945 67.6305 30.9558 68.2702 30.7946 68.8842C30.6333 69.4982 30.3527 70.0744 29.9687 70.58C29.5848 71.0855 29.105 71.5105 28.5568 71.8306C28.0086 72.1507 27.4027 72.3596 26.7737 72.4456C23.2686 72.9234 20.3616 73.5435 18.1657 74.2188C18.8742 74.437 19.6752 74.6538 20.5687 74.8665C25.8774 76.126 33.4565 76.9519 42.0024 76.9519C50.5454 76.9519 58.1246 76.126 63.4333 74.8665C64.241 74.6766 65.0424 74.4606 65.8363 74.2188C63.6404 73.5435 60.7333 72.9234 57.2283 72.4456C55.958 72.2721 54.8087 71.6012 54.0332 70.5804C53.2576 69.5596 52.9193 68.2725 53.0928 67.0022C53.2662 65.732 53.9371 64.5827 54.9579 63.8071C55.9788 63.0316 57.2659 62.6933 58.5361 62.8667C63.5106 63.5462 67.9492 64.5543 71.2748 65.8898C72.9154 66.5486 74.5602 67.3951 75.8764 68.5207C77.1635 69.6227 78.7227 71.523 78.7227 74.2188C78.7227 78.152 75.5256 80.3838 73.7482 81.3795C71.5717 82.6003 68.7433 83.5422 65.665 84.2727C59.4324 85.7505 51.0675 86.6205 42.001 86.6205C32.9345 86.6205 24.5696 85.7505 18.337 84.2727C15.2586 83.5422 12.4303 82.6017 10.2538 81.3795C8.47777 80.3838 5.2793 78.152 5.2793 74.2188C5.2793 71.523 6.83987 69.6227 8.12561 68.5207C9.44173 67.3937 11.0865 66.5486 12.7286 65.8898C16.0541 64.5543 20.4928 63.5462 25.4659 62.8667C26.0948 62.7809 26.7345 62.8198 27.3484 62.9813C27.9624 63.1427 28.5385 63.4235 29.0439 63.8076C29.5493 64.1916 29.9741 64.6715 30.294 65.2198C30.6139 65.768 30.8228 66.3726 30.9085 67.0015Z",
    fill: "url(#paint1_radial_59_3757)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_59_3757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.84601 -61.3652) scale(161.554 138.515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2E432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#399A48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_59_3757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.76913 37.5402) scale(164.667 53.358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2E432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#399A48"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a94397697e381e134aea4ad38e83f414.svg";
export { ForwardRef as ReactComponent };